<ng-container *ngIf="appearance === 'default'">
    <input [placeholder]="placeholder" (ngModelChange)="formatPhone()" type="text" max="15" class="form-control form-control-sm" appStaticEdit [editable]="editable" [(ngModel)]="number" #input />
</ng-container>
<ng-container *ngIf="appearance === 'outline'">
    <mat-form-field class="w-100 non-default mat-input-no-message" appearance="outline">
        <mat-label>{{ placeholder }}</mat-label>
        <input matInput [placeholder]="placeholder" (ngModelChange)="formatPhone()" type="text" max="15" appStaticEdit [editable]="editable" [(ngModel)]="number" #input />
    </mat-form-field>
</ng-container>